module.exports = {"educators":{"title":"Teach","subtitle":"Teach your students","slug":"/teach"},"learn":{"title":"Learn","subtitle":"Try OcuChess to reach your max potential!","slug":"/learn"},"getInvolved":{"title":"Get Involved","subtitle":"Support Chess and cognitive learning","slug":"/help-us"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/home/en/cards.yml
// module id = 951
// module chunks = 173894859265406